import * as angular from "angular";
import {IController} from "angular";
import {BillingOrder} from "../../models/billing-order.model";
import * as _ from "lodash";


export class BillingOrderAgentsListDisplayComponent implements IController {

  billingOrder: BillingOrder;
  maxItems?: number;

  public agentsNames: string[];


  constructor() {

  }

  $onInit() {

    if (!this.maxItems) {
      this.maxItems = 1;
    }

    this._initItems();
  }

  $onChanges(changes: angular.IOnChangesObject) {
    if (changes.billingOrder && !changes.billingOrder.isFirstChange()) {
      this._initItems();
    }
  }

  private _initItems() {
    this.agentsNames = _.chain(this.billingOrder.billingInfoLines)
      .flatMap('billingInfoSteps')
      .map('agentReference.fullName')
      .compact()
      .value();
  }

}

angular
  .module('bringoz.admin.billing-accounts')
  .component('billingOrderAgentsListDisplay', {
    bindings: {
      billingOrder: '<',
      maxItems: '<?'
    },
    template: require('./billing-order-agents-list-display.html').default,
    controller: BillingOrderAgentsListDisplayComponent
  });
